import createHash from "create-hash";
import randomBytes from "randombytes";
import { SHA3 } from "sha3";

/* UTILITY FUNCTIONS */
function base64URLEncode(str) {
  return str
    .toString("base64")
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
}
function sha256(buffer) {
  return createHash("sha256").update(buffer).digest();
}
function generateRandomString(length, randomString = "") {
  randomString += Math.random().toString(20).substr(2, length);
  if (randomString.length > length) return randomString.slice(0, length);
  return generateRandomString(length, randomString);
}
function getQueryVar(variableName) {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] == variableName) {
      return pair[1];
    }
  }
  return false;
}
function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}
/* UTILITY FUNCTIONS END */

/* CONSTANTS */
export const STATE = generateRandomString(16);
export const GRANT_TYPE = "authorization_code";
export const REDIRECT_URI = location.origin + location.pathname;
export const SCOPE = "openid%20offline";
export const BASE_AUTH_URL_STG = "https://bg-auth-public.stg.bodygram.cc";
export const BASE_AUTH_URL_PRD = "https://bg-auth-public.bodygram.com";
const BASE_ENTRY_URL_STG = "https://member.stg.bodygram.cc/entry";
const BASE_ENTRY_URL_PRD = "https://member.bodygram.com/entry";
const POPUP_NAME = "bodygramPopup";
const CODE_VERIFIER = base64URLEncode(randomBytes(32));
const CODE_CHALLENGE = base64URLEncode(sha256(CODE_VERIFIER));
const CODE_CHALLENGE_METHOD = "S256";
const RESPONSE_TYPE = "code";
const NONCE = generateRandomString(16);
/* CONSTANTS END */

function createPopup(url) {
  const options = {
    toolbar: 0,
    resizable: 1,
    scrollbars: 1,
    width: 500,
    height: 550,
    location: 1,
    menuBar: 0,
  };
  const optionsArray = [];
  Object.keys(options).forEach(function (name) {
    var value = options[name];
    optionsArray.push(name + (value !== null ? "=" + value : ""));
  });
  window.open(url, POPUP_NAME, optionsArray.join(","));
}

export const openBodygramLogin = function (messageData, popup = false) {
  const authParams = {
    response_type: RESPONSE_TYPE,
    client_id: messageData.client_id,
    redirect_uri: REDIRECT_URI,
    state: STATE,
    scope: SCOPE,
    nonce: NONCE,
    code_challenge: CODE_CHALLENGE,
    code_challenge_method: CODE_CHALLENGE_METHOD,
    email: messageData.email,
  };

  if (messageData.directEntry) {
    authParams.login_type = "direct_email";
    authParams.email = encodeURIComponent(messageData.email);
  }

  const paramsArray = [];
  Object.keys(authParams).forEach(function (name) {
    const value = authParams[name];
    paramsArray.push(`${name}=${value}`);
  });
  const baseUrl =
    messageData.env === "staging" ? BASE_ENTRY_URL_STG : BASE_ENTRY_URL_PRD;
  const url = `${baseUrl}?${paramsArray.join("&")}`;
  if (popup) {
    createPopup(url);
  } else {
    window.location.href = url;
  }

  // save code verifier to use in other static iframe
  localStorage.setItem("BODYGRAM_CODE_VERIFIER", CODE_VERIFIER);
};

export const saveDataFromBodygramLocalStorage = function () {
  const code = getQueryVar("code");
  const scope = getQueryVar("scope");
  const state = getQueryVar("state");
  if (!code && !scope && !state) return;
  if (window.opener) {
    window.opener.postMessage(
      JSON.stringify({
        name: "bodygram-auth-code-response",
        data: { code, scope, state },
      })
    );
    window.close();
  } else {
    localStorage.setItem(
      "bodygramAuth",
      JSON.stringify({ code, scope, state })
    );
  }
};

export const formatBodygramResponse = function (response) {
  if (!response.id_token) return response;

  const bodygram_id_token = parseJwt(response.id_token).sub;
  const hash = new SHA3(256);
  hash.update(bodygram_id_token);
  return {
    accessToken: response.access_token,
    bodygramUid: hash.digest("hex"),
    bodygramRefreshToken: response.refresh_token,
  };
};
